export default __webpack_public_path__ + "static/media/yarden_website_fullscreen.1885eb87.png";